import BaseService from "@/services/baseService";

export default class EngiService extends BaseService {
    static async ricetta(datiRicetta,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/ricetta",
            method: "POST",
            headers: {},
            body: datiRicetta
        });
        if(response.status === 401 && tentativo<3){
           return await EngiService.ricetta(datiRicetta,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async prestazioniErogabiliAlpi(testoricerca,tentativo=0) {
        const response =  await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/alpi/prestazionierogabili",
            method: "GET",
            headers: {},
            params: {"testo": testoricerca},
            timeout: 40000
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.prestazioniErogabiliAlpi(testoricerca,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async unitaOperativeAlpi(idPrestazione,tentativo=0) {
        const response =  await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/alpi/unitaOperative",
            method: "GET",
            headers: {},
            params: {"idPrestazione": idPrestazione},
            timeout: 40000
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.unitaOperativeAlpi(idPrestazione,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async ricercaDisponibilitaAlpi(parametriDisponibilita,tentativo=0) {
        const response =  await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/alpi/ricercaDisponibilita",
            method: "POST",
            headers: {},
            body: parametriDisponibilita,
            timeout: 40000
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.ricercaDisponibilitaAlpi(parametriDisponibilita,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async confermaPrenotazioneAlpi(parametriConferma,tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/alpi/confermaPrenotazione",
            method: "POST",
            headers: {},
            body: parametriConferma,
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.confermaPrenotazioneAlpi(parametriConferma,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async confermaPrenotazioneNre(parametriConferma,tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/confermaappuntamento",
            method: "POST",
            headers: {},
            body: parametriConferma,
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.confermaPrenotazioneNre(parametriConferma,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async annullaPrenotazioneSospesa(tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/annullaprenotazionesospesa",
            method: "GET",
            headers: {},
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.annullaPrenotazioneSospesa(tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async ricercaDisponibilitaNre(parametriDisponibilita,tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/ricercaprimadisponibilita/ricercadata",
            method: "GET",
            headers: {
                "dataricerca": parametriDisponibilita
            },
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.ricercaDisponibilitaNre(parametriDisponibilita,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async ricercaDisponibilitaProssimaNre(sedeSelezionata, dataRicerca, paramentriDisponibilita,tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/ricercaDisponibilitaProssima/",
            method: "POST",
            headers: {
                "dataricerca": dataRicerca,
            },
            params: {sede: sedeSelezionata},
            body: paramentriDisponibilita
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.ricercaDisponibilitaProssimaNre(sedeSelezionata, dataRicerca, paramentriDisponibilita,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async ricercaPrimaDisponibilitaNre(parametriDisponibilita, idSede,tentativo=0) {
        if (idSede) {
            const response = await this.perfom({
                url: "/api/v2.0/appecupt/aslengi/ricercaDisponibilita/",
                method: "POST",
                headers: {},
                params: {sede: idSede},
                body: parametriDisponibilita,
            });
            if(response.status === 401 && tentativo<3){
                return await EngiService.ricercaPrimaDisponibilitaNre(parametriDisponibilita, idSede,tentativo+1)
            }
            else if(response.status === 401 && tentativo>=3)
            {
                sessionStorage.clear()
                await window.alert("sessione scaduta, rieffettuare l'accesso")
                window.location.reload();
                return response
            }
            else
                return response;
        }
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/ricercaDisponibilita",
            method: "POST",
            headers: {},
            body: parametriDisponibilita,
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.ricercaPrimaDisponibilitaNre(parametriDisponibilita, idSede,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async listaSedi(parametriDisponibilita,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/prentemp/sedi",
            method: "POST",
            headers: {},
            body: parametriDisponibilita
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.listaSedi(parametriDisponibilita,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async listaAppuntamenti(cfAssistito,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/listaappuntamenti",
            method: "POST",
            headers: {},
            body: {
                codiceFiscale: cfAssistito
            },
            timeout: 40000
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.listaAppuntamenti(cfAssistito,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async stampaRicevutaPrenotazione(parametriRicevuta,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/stampaInvioRicevuta",
            method: "POST",
            headers: {},
            body: parametriRicevuta
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.stampaRicevutaPrenotazione(parametriRicevuta,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async annullaPrenotazione(parametriAnnullamento,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/annullaImpegnativa",
            method: "POST",
            headers: {},
            body: parametriAnnullamento
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.annullaPrenotazione(parametriAnnullamento,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async listaPendenze(parametriPendenze,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/listaPagamenti",
            method: "POST",
            headers: {},
            body: parametriPendenze
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.listaPendenze(parametriPendenze,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async pagamento(parametriPagamento,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/purchase",
            method: "POST",
            headers: {},
            body: parametriPagamento
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.pagamento(parametriPagamento,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async stampaAvvisoPagamento(parametriRicevuta,tentativo=0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/stampaAvvisoPagamento",
            method: "POST",
            headers: {},
            body: parametriRicevuta
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.stampaAvvisoPagamento(parametriRicevuta,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async stampaRicevutaPagamento(parametriScaricaAvviso,tentativo= 0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/stampaRicevutaPagamento",
            method: "POST",
            headers: {},
            body: parametriScaricaAvviso
        })
        if(response.status === 401 && tentativo<3){
            return await EngiService.stampaRicevutaPagamento(parametriScaricaAvviso,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async storicoPagamenti(tentativo= 0) {
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/aslengi/listaPagati",
            method: "GET",
            headers: {},
        });
        if(response.status === 401 && tentativo<3){
            return await EngiService.storicoPagamenti(tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }
}
